import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-plaid-logo',
  templateUrl: './icon-plaid-logo.component.html'
})
export class IconPlaidLogoComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
